import React, { useEffect, useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import styled from 'styled-components';
import {
  RecapContainer,
  RegulationRecapContainer,
  RiskContainer,
  Title,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/styled-components';
import messages from 'containers/CourtManagerLegalProceedings/Provision/Regulation/messages';
import emptyBox from 'images/emptyBox.svg';
import { translate } from 'containers/services/translate';
import { connect } from 'react-redux';
import { get, isEmpty, isEqual, isNil } from 'lodash';
import { createStructuredSelector } from 'reselect';
import {
  requestGetRegulation,
  requestSagisClaimInfo,
  requestValidateRegulation,
} from 'containers/CourtManagerLegalProceedings/Provision/redux/actions';
import {
  makeSelectRegulation,
  makeSelectSagisClaim,
} from 'containers/CourtManagerLegalProceedings/Provision/redux/selectors';
import AdultRegulationRecap from 'containers/CourtManagerLegalProceedings/Provision/Regulation/Recap/AdultVictimRegulation';
import { RcCorporeal } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/typings';
import { Listings } from 'containers/AppContainer/typings';
import { makeSelectListings } from 'containers/AppContainer/selectors';
import SahamAccordion from 'components/SahamAccordion';
import RegulationInformation from 'containers/CourtManagerLegalProceedings/Provision/Regulation/Recap/RegulationInformationRecap';
import { rcCoporeal } from 'containers/CourtManagerLegalProceedings/constants';
import { REGULATIONS } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/data-structure';
import { getDocumentNature } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/utils';
import moment from 'moment';
import {
  EXPAND_RISK,
  IDD_CHECK,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/Recap/constants';
import MinorRegulationRecap from 'containers/CourtManagerLegalProceedings/Provision/Regulation/Recap/MinorVictimRegulation/index';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { BUTTON_COLORS } from 'constants/design';
import RegulationValidationDrawer from 'containers/CourtManagerLegalProceedings/Provision/Regulation/RegulationValidationDrawer';
import useDeepCompareEffect from 'use-deep-compare-effect';
import {
  isBlockStatusClaim,
  isLockedClaim,
} from 'containers/CourtManagerLegalProceedings/utils';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { STATUS_VALIDATED } from 'containers/LawyerFeeNote/constants';
import { makeSelectSearchClaims } from 'containers/IdentificationPage/selectors';
import { makeSelecClaimRecap } from 'containers/RecapManagerPage/selectors';
import { requestLockClaim } from 'containers/CourtManagerLegalProceedings/actions';
import { setLockedClaim } from 'containers/LawyerLegalProceedingsPage/actions';
import {
  DOCUMENT_MAPPER,
  getStatusByKey,
  PAYMENT_CHANNEL_MAPPER,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/constants';
import { TIMELINE_REGULATION_STATUS } from 'containers/data-structure';
import Document from 'components/Document';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { ClaimRecapType } from 'typings/claimTypes';

export interface RegulationRecapPageProps {
  intl: IntlShape;
  requestSagisClaimInfo: Function;
  requestGetRegulation: Function;
  requestValidateRegulation: Function;
  sagisClaim: any;
  listings: Listings;
  match: { params: { paymentId: number; claimId: number } };
  corpoRegulation: any;
  policyInfo: any;
  claimRecap: ClaimRecapType;
  requestLockClaim: Function;
  setLockedClaim: Function;
  setOPenRecap: Function;
  isRecap?: boolean;
  isConsultation: boolean;
  isBasicManagementRegulation?: boolean;
}

const GlobalBloc = styled.div`
  &&.globalBloc {
    position: relative;
  }
`;
const ButtonContainer = styled.div`
  display: flex;
  justify-content: end;
  gap: 20px;
  margin: 20px 20px 0px 0px;
  margin-bottom: 20px;
`;
export const RegulationRecapPage: React.FC<RegulationRecapPageProps> = (
  props,
): JSX.Element => {
  useDeepCompareEffect(() => {
    if (!isEmpty(get(props.policyInfo, 'sagis', []))) {
      if (
        !isLockedClaim(props.policyInfo) &&
        featureService.hasFeature(FEATURES.AUTOMATIC_LOCK_CLAIM) &&
        !isNil(get(props.claimRecap, 'claim.claimNumber', null)) &&
        !isBlockStatusClaim(props.policyInfo) &&
        get(props, 'claimRecap.claim.status') === STATUS_VALIDATED
      ) {
        props.requestLockClaim({
          claimNumber: get(props.claimRecap, 'claim.claimNumber'),
        });
        props.setLockedClaim(get(props.claimRecap, 'claim.claimNumber'));
      }
    }
  }, [props.claimRecap, props.policyInfo]);
  const [isOpenValidationDrawer, setIsOpenValidationDrawer] = useState(false);
  const claimNumber = get(props.claimRecap, 'claim.claimNumber');
  const currentRegulation = get(props.sagisClaim, 'regulations', []).find(
    (regulation: any) =>
      parseInt(regulation.paymentId) === get(props.match.params, 'paymentId'),
  );

  const encryptedDocumentsOfAdults = get(
    currentRegulation,
    'documentChiffre.documentChiffreCorporel.documentHeader.victimsDetailModel',
    [],
  )
    .filter((item: any) => isEqual(get(item, 'indemnityCNRA'), 0))
    .map((item: any) => {
      get(props.corpoRegulation, 'regulationVictims', []).find((el: any) => {
        if (
          isEqual(parseInt(get(el, 'victim.victimKey')), get(item, 'victimKey'))
        ) {
          item = {
            ...item,
            cnraAmount: get(el, 'judgementGlobalAmount', 0),
          };
          return item;
        } else {
          return item;
        }
      });
      return item;
    });

  const encryptedDocumentsOfMinors = get(
    currentRegulation,
    'documentChiffre.documentChiffreCorporel.documentHeader.victimsDetailModel',
    [],
  )
    .filter((item: any) => !isEqual(get(item, 'indemnityCNRA'), 0))
    .map((item: any) => {
      get(props.corpoRegulation, 'regulationVictims', []).find((el: any) => {
        if (
          isEqual(parseInt(get(el, 'victim.victimKey')), get(item, 'victimKey'))
        ) {
          item = {
            ...item,
            cnraAmount: get(el, 'judgementGlobalAmount', 0),
          };
          return item;
        } else {
          return item;
        }
      });
      return item;
    });

  const rcCorporeal = {
    regulationInfo: {
      ...currentRegulation,
      [REGULATIONS.PROCESS_NATURE]: get(
        props.corpoRegulation,
        'judgement.judiciaryProcess.procedureNatureId',
      ),
      [REGULATIONS.BNEJ_NUMBER]: get(
        currentRegulation,
        'documentChiffre.documentChiffreCorporel.BNEJ.BNEJNumber',
      ),
      [REGULATIONS.REGULATION_NATURE]: String(
        get(
          currentRegulation,
          'documentChiffre.documentChiffreCorporel.documentHeader.natureCode',
        ),
      ),
      [REGULATIONS.BNEJ_NUMBER]: get(
        currentRegulation,
        'documentChiffre.documentChiffreCorporel.BNEJ.BNEJNumber',
      ),
      [REGULATIONS.CITY_CODE]: String(
        get(
          currentRegulation,
          'documentChiffre.documentChiffreCorporel.documentHeader.cityCode',
        ),
      ),
      [REGULATIONS.BENEFICIARY_RECIPIENT]: get(
        currentRegulation,
        'beneficiaryReference',
        '',
      ).split(' ')[0],
      [REGULATIONS.OPPOSING_LAWYER]: get(
        props.corpoRegulation,
        'opposingLawyer.name',
      ),
      [REGULATIONS.OPPOSING_LAWYER_CITY]: get(
        props.corpoRegulation,
        'opposingLawyer.city',
      ),
      [REGULATIONS.OPPOSING_LAWYER_ADDRESS]: get(
        props.corpoRegulation,
        'opposingLawyer.address',
      ),
      [REGULATIONS.OPPOSING_LAWYER_EMAIL]: get(
        props.corpoRegulation,
        'opposingLawyer.email',
      ),
      [REGULATIONS.IS_APPEAL]: props.isBasicManagementRegulation
        ? get(props.listings, 'EncryptDocumentNature', []).find(
            item =>
              item.ItemKey.toString() ===
              get(
                currentRegulation,
                'documentChiffre.documentChiffreCorporel.documentHeader.natureCode',
                '',
              ).toString(),
          )?.ItemDescription === 'Arrét'
        : get(props.corpoRegulation, 'judgement.procedureType') === 'APPEAL',
      [REGULATIONS.JUDGEMENT_DATE]: moment(
        get(
          currentRegulation,
          'documentChiffre.documentChiffreCorporel.documentHeader.arrestDate',
        ),
      ).format('DD/MM/YYYY'),
      [REGULATIONS.REGULATION_DATE]: moment(
        get(
          currentRegulation,
          'documentChiffre.documentChiffreCorporel.documentHeader.settlementDate',
        ),
      ).format('DD/MM/YYYY'),
      [REGULATIONS.TPI]: String(
        get(
          currentRegulation,
          'documentChiffre.documentChiffreCorporel.documentHeader.TPI',
        ),
      ),
      [REGULATIONS.APPEAL_COURTS]: String(
        get(
          currentRegulation,
          'documentChiffre.documentChiffreCorporel.documentHeader.appealCourts',
        ),
      ),
      [REGULATIONS.COUNTRY_CODE]: String(
        get(
          currentRegulation,
          'documentChiffre.documentChiffreCorporel.documentHeader.countryCode',
        ), // field not available
      ),
      [REGULATIONS.TOWN_CODE]: String(get(currentRegulation, 'townCode')),
      [REGULATIONS.BNEJ_TAX_AMOUNT]: String(
        get(
          currentRegulation,
          'documentChiffre.documentChiffreCorporel.BNEJ.taxAmount',
        ),
      ),
      [REGULATIONS.DIRECT_INDEMNITY_COSTS]: get(
        currentRegulation,
        'documentChiffre.documentChiffreCorporel.directCompensation.costsAmount',
      ),
      [REGULATIONS.IS_IDD_CHECKED]:
        get(
          currentRegulation,
          'documentChiffre.documentChiffreCorporel.deduction.rateValue',
        ) !== 100
          ? IDD_CHECK.TRUE
          : IDD_CHECK.FALSE,
      [REGULATIONS.CALCULATION_START_DATE]: get(
        props.corpoRegulation,
        'jom.calculationStartDate',
        '',
      ),
      [REGULATIONS.JUDGEMENT_DATE_JAF]: moment(
        get(
          currentRegulation,
          'documentChiffre.documentChiffreCorporel.documentHeader.judgementDate',
        ),
      ).format('DD/MM/YYYY'),
      [REGULATIONS.DEDUCTION_RATE]: get(
        currentRegulation,
        'documentChiffre.documentChiffreCorporel.deduction.rateValue',
      ),
      [REGULATIONS.ADDITIONAL_ADDRESS]: get(
        currentRegulation,
        'adressRecipient',
      ),
      isRecap: props.isRecap,
      isBnej:
        get(currentRegulation, 'PaymentChannelCode') ===
        PAYMENT_CHANNEL_MAPPER.BNEJ,
    },
    victimsCorpo: get(props.claimRecap, 'victims', []),
    data: [
      ...get(props.corpoRegulation, 'regulationVictims', []).map((el: any) => {
        return {
          ...el.victim,
          regulationAmount: {
            ...encryptedDocumentsOfAdults.find(
              (item: any) =>
                Number(item.victimKey) === Number(get(el, 'victim.victimKey')),
            ),
          },
          beneficiaries: [
            ...get(
              get(props.corpoRegulation, 'beneficiariesRegulation', []).find(
                (item: any) => get(el, 'victim.id') === item.victimId,
              ),
              'beneficiaries',
              [],
            ),
          ],
        };
      }),
    ],
    regulationId: props.match.params.paymentId,
  };
  const isRegulationPending =
    getStatusByKey(get(currentRegulation, 'paymentStatusCode')) ===
    TIMELINE_REGULATION_STATUS.PENDING;

  useEffect(() => {
    props.requestGetRegulation(get(props.match.params, 'paymentId'));
    props.requestSagisClaimInfo(claimNumber);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params.paymentId]);
  return (
    <GlobalBloc className="globalBloc">
      <RegulationRecapContainer height={null}>
        <Title className="recap-title">
          {translate(messages.regulationRecapTitle, props)}
        </Title>
        <RiskContainer>
          <RecapContainer>
            {isEmpty(props.sagisClaim) ? (
              <div className="no-data">
                <img src={emptyBox} alt="empty box" />
                <span style={{ display: 'block' }} className="title">
                  {translate(messages.noDataTitle, props)}
                </span>
              </div>
            ) : (
              <div>
                <SahamAccordion
                  key={get(currentRegulation, 'paymentId')}
                  title={rcCoporeal}
                  expanded={true}
                  onChange={() => {}}
                >
                  <div>
                    <RegulationInformation
                      rcCorporeal={rcCorporeal as RcCorporeal}
                      listings={props.listings}
                      corpoEncryptedDocuments={get(
                        currentRegulation,
                        'corpoEncryptedDocuments',
                      )}
                      substituteDocumentNature={getDocumentNature(
                        get(props.listings, 'EncryptDocumentNature', []),
                        get(props.corpoRegulation, 'judgement'),
                        rcCorporeal,
                        props.sagisClaim,
                        true,
                        get(props.listings, 'PaymentStatus', []),
                        props.isBasicManagementRegulation,
                      )}
                      corpoEncryptedDocumentsResult={get(
                        currentRegulation,
                        'corpoEncryptedDocumentsResult',
                      )}
                      expanded={true}
                      handleChangeExpanded={() => {}}
                      isBasicManagementRegulation={
                        props.isBasicManagementRegulation
                      }
                    />
                    {!isEmpty(encryptedDocumentsOfAdults) && (
                      <AdultRegulationRecap
                        rcCorporeal={rcCorporeal as RcCorporeal}
                        listings={props.listings as any}
                        encryptedDocumentsOfAdults={{
                          totalAmount: get(
                            currentRegulation,
                            'documentChiffre.documentChiffreCorporel.directCompensation.totalAmount',
                            '',
                          ),
                          encryptedDocumentsOfAdults,
                        }}
                        setEncryptedDocumentsOfAdults={() => {}}
                        corpoEncryptedDocuments={[]}
                        substituteDocumentNature={getDocumentNature(
                          get(props.listings, 'EncryptDocumentNature', []),
                          get(props.corpoRegulation, 'judgement'),
                          rcCorporeal,
                          props.sagisClaim,
                          true,
                          get(props.listings, 'PaymentStatus', []),
                          props.isBasicManagementRegulation,
                        )}
                        corpoEncryptedDocumentsResult={[]}
                        expanded={{
                          [rcCorporeal.regulationId]: {
                            [EXPAND_RISK.ADULT]: true,
                          },
                        }}
                        handleChangeExpanded={() => {}}
                        handleChange={() => {}}
                        lossDate={null}
                        regulations={[]}
                        corpoRegulations={get(
                          currentRegulation,
                          'corpoRegulations',
                          [],
                        )}
                        isRecap={props.isRecap}
                      />
                    )}
                    {!isEmpty(encryptedDocumentsOfMinors) && (
                      <MinorRegulationRecap
                        rcCorporeal={rcCorporeal as RcCorporeal}
                        listings={props.listings}
                        encryptedDocumentsOfMinors={{
                          totalAmount: get(
                            currentRegulation,
                            'documentChiffre.documentChiffreCorporel.CNRA.totalAmount',
                            '',
                          ),
                          encryptedDocumentsOfMinors,
                        }}
                        encryptedDocumentsOfAdults={[]}
                        setEncryptedDocumentsOfMinors={() => {}}
                        corpoEncryptedDocuments={[]}
                        substituteDocumentNature={getDocumentNature(
                          get(props.listings, 'EncryptDocumentNature', []),
                          get(props.corpoRegulation, 'judgement'),
                          rcCorporeal,
                          props.sagisClaim,
                          true,
                          get(props.listings, 'PaymentStatus', []),
                          props.isBasicManagementRegulation,
                        )}
                        corpoEncryptedDocumentsResult={[]}
                        expanded={{
                          [rcCorporeal.regulationId]: {
                            [EXPAND_RISK.MINOR]: true,
                          },
                        }}
                        handleChangeExpanded={() => {}}
                        handleChange={() => {}}
                        lossDate={null}
                        regulations={[]}
                        corpoRegulations={get(
                          currentRegulation,
                          'corpoRegulations',
                          [],
                        )}
                        isRecap={props.isRecap}
                      />
                    )}
                    {!isEmpty(get(props.corpoRegulation, 'documents', [])) && (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '10px',
                        }}
                      >
                        {get(props.corpoRegulation, 'documents', []).map(
                          (doc: {
                            id: string;
                            type: keyof typeof DOCUMENT_MAPPER;
                            url: string;
                          }) => (
                            <Document
                              key={doc.id}
                              name={DOCUMENT_MAPPER[doc.type]}
                              type={DOCUMENT_MAPPER[doc.type]}
                              icon={
                                //to-update
                                <a
                                  href={doc.url}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <VisibilityIcon
                                    style={{ color: 'black' }}
                                    className="consult"
                                  />
                                </a>
                              }
                            />
                          ),
                        )}
                      </div>
                    )}
                  </div>
                </SahamAccordion>
              </div>
            )}
          </RecapContainer>
        </RiskContainer>
        <ButtonContainer>
          <PrimaryButton
            background={BUTTON_COLORS.PRIMARY_BLUE}
            border={BUTTON_COLORS.PRIMARY_BLUE}
            titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
            title={translate(messages.validationRegulationButton, props)}
            onClick={() => setIsOpenValidationDrawer(true)}
          />

          <PrimaryButton
            background={BUTTON_COLORS.PRIMARY_BLUE}
            border={BUTTON_COLORS.PRIMARY_BLUE}
            titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
            title={translate(messages.back, props)}
            data-testid="back-to-historic"
            onClick={() => {
              props.setOPenRecap(false);
            }}
          />
        </ButtonContainer>
        <RegulationValidationDrawer
          open={isOpenValidationDrawer}
          requestValidateRegulation={props.requestValidateRegulation}
          requestGetRegulation={props.requestGetRegulation}
          regulationId={get(props.match.params, 'paymentId')}
          corpoRegulationId={get(props.corpoRegulation, 'id')}
          claimNumber={claimNumber}
          claimId={
            get(props.corpoRegulation, 'judgement.claimId') ||
            get(props.match.params, 'claimId')
          }
          handleToggleDrawer={() =>
            setIsOpenValidationDrawer(!isOpenValidationDrawer)
          }
          history={get(
            props.corpoRegulation,
            'regulationValidationHistory',
            [],
          )}
          regulationRejectionInfo={get(
            props.corpoRegulation,
            'regulationRejectionReason',
            {},
          )}
          isConsultation={props.isConsultation}
          isRegulationPending={isRegulationPending}
          listings={props.listings}
        />
      </RegulationRecapContainer>
    </GlobalBloc>
  );
};

const mapDispatchToProps = {
  requestSagisClaimInfo,
  requestGetRegulation,
  requestValidateRegulation,
  requestLockClaim,
  setLockedClaim,
};
const mapStateToProps = createStructuredSelector({
  sagisClaim: makeSelectSagisClaim(),
  listings: makeSelectListings(),
  corpoRegulation: makeSelectRegulation(),
  policyInfo: makeSelectSearchClaims(),
  claimRecap: makeSelecClaimRecap(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(RegulationRecapPage));
